import { BASE_URI } from '../config';

export const getFileSrc = (fileID: string) =>
  `${BASE_URI}/api/storage/download/file/${fileID}`;
